<template>
    <div class="space-y-6 col-span-1">
        <div class="-mr-4 bg-white col-span-1 overflow-hidden shadow rounded-lg divide-y divide-gray-200 w-full">
            <div class="px-4 py-3 sm:px-4">
                <div class="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap">
                    <div class="ml-4 mt-2">
                        <h3 class="text-base leading-6 font-medium text-gray-900">
                            {{ $t('message.detenciones.detenciones') }}
                        </h3>
                    </div>
                </div>
            </div>
            <div class="px-4 py-6 grid grid-cols-4" align="center">
                <div class="col-span-3">
                    <span class="rounded-md shadow-sm">
                        <button type="button" @click="showModal" class="items-center px-3 py-2 border border-gray-300 text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:text-gray-800 active:bg-gray-50 transition ease-in-out duration-150">
                            {{$t('message.detenciones.agregardetencion')}}
                        </button>
                    </span>
                </div>
                <span class="rounded-md shadow-sm">
                    {{$t('message.detenciones.simbologia')}}
                    <ul class="text-left">
                        <li>
                            <p class="text-xs">
                                <span class="bg-blue-400 px-1 py-1 text-xs inline-flex border border-gray-300 bg-white leading-4 text-gray-700">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                    </svg>
                                </span>
                                {{$t('message.detenciones.editardetencion')}}
                            </p>
                        </li>
                        <li>
                            <p class="text-xs">
                                <span class="bg-yellow-400 px-1 py-1 text-xs inline-flex border border-gray-300 bg-white leading-4 text-gray-700">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                    </svg>
                                </span> 
                                {{$t('message.detenciones.agregarnodo')}}
                            </p>
                        </li>
                        <li>
                            <p class="text-xs">
                                <span class="bg-green-400 px-1 py-1 text-xs inline-flex border border-gray-300 bg-white leading-4 text-gray-700">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                    </svg>
                                </span>
                                {{$t('message.detenciones.activardesactivardetencion')}}
                            </p>
                        </li>
                        <li>
                            <p class="text-xs">
                                <span class="bg-red-400 px-1 py-1 text-xs inline-flex border border-gray-300 bg-white leading-4 text-gray-700">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </span>
                                {{$t('message.detenciones.eliminarnodo')}}
                            </p>
                        </li>
                    </ul>
                </span>
            </div>
            <div class="px-4 py-6">
                <tree-table
                    class="overflow-y-visible"
                    v-for="item in data"
                    :key="item.id"
                    :item="item"
                    :headers="headers"
                />
                    <!--<tree-table :headers="headers" :items="data" :idChanged="idChanged" />-->
            </div>
        </div>
        <modal :open="openModalCreate" @closeModal="openModalCreate = false" :title="$t('message.detenciones.titulomodal')" :maxWidth="40" >
            <form @submit.prevent="submitForm">
                <div class="grid grid-cols-6 gap-6">
                    <div class="col-span-3">
                        <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.detenciones.nodopadre')}}</label>
                        <select v-model.number="formData.parent_id" class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                            <option value=""> </option>
                            <option v-for="d in dataListFiltered" :key="d.id" :value="d.id" > {{d.description}} </option>
                        </select>
                        <small>* {{$t('message.detenciones.avisosinnodopadre')}}</small>
                    </div>
                    <div class="col-span-3">
                        <label class="block text-sm font-medium leading-5 text-gray-700">{{$t('message.detenciones.description')}} *</label>
                        <input type="text" v-model.trim="formData.description" class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                    </div>
                    <div class="col-span-3">
                        <label class="block text-sm font-medium leading-5 text-gray-700"> {{$t('message.detenciones.codigo')}} </label>
                        <input type="number" v-model.number="formData.code" class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                    </div>
                    <template v-if="isSupport">
                        <div class="col-span-6">
                            <div class=" inset-0 flex items-center" aria-hidden="true">
                                <div class="w-full border-t border-gray-300"></div>
                            </div>
                            <div class="relative flex justify-center">
                                <span class="px-2 bg-white text-sm text-gray-500">
                                    {{$t('message.detenciones.usointerno')}}
                                </span>
                            </div>
                        </div> 	 	
                        <div class="col-span-2">
                            <label class="block text-sm font-medium leading-5 text-gray-700"> code_f </label>
                            <input type="text" v-model.trim="formData.code_f" class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                        </div>
                        <div class="col-span-2">
                            <label class="block text-sm font-medium leading-5 text-gray-700"> code_l </label>
                            <input type="text" v-model.trim="formData.code_l" class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                        </div>
                        <div class="col-span-2">
                            <label class="block text-sm font-medium leading-5 text-gray-700"> code_m </label>
                            <input type="text" v-model.trim="formData.code_m" class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                        </div>
                        <div class="col-span-2">
                            <label class="block text-sm font-medium leading-5 text-gray-700"> code_n </label>
                            <input type="text" v-model.trim="formData.code_n" class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                        </div>
                        <div class="col-span-2">
                            <label class="block text-sm font-medium leading-5 text-gray-700"> code_t </label>
                            <input type="text" v-model.trim="formData.code_t" class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                        </div>
                        <div class="col-span-2">
                            <label class="block text-sm font-medium leading-5 text-gray-700"> code_u </label>
                            <input type="text" v-model.trim="formData.code_u" class="mt-1 form-input block w-full py-1 px-2 rounded shadow-sm transition duration-150 ease-in-out sm:text-sm sm:leading-5">
                        </div>
                        <div class="col-span-2">
                            <label class="block text-sm font-medium leading-5 text-gray-700"> productsetup </label>
                            <div class="flex items-center mt-3">
                                <input v-model="formData.productsetup" type="checkbox" class="form-radio h-4 w-4 text-indigo-600 transition duration-150 ease-in-out">
                            </div>
                        </div>
                    </template>
                    <div class="col-span-full" align="right">
                        <span class="rounded-md shadow-sm">
                            <button type="submit" class="items-center px-3 py-2 border border-gray-300 text-sm leading-4 font-medium rounded-md text-gray-700 bg-green-200 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:text-gray-800 active:bg-gray-50 transition ease-in-out duration-150">
                                {{$t('message.detenciones.guardarcambios')}}
                            </button>
                        </span>
                    </div>
                </div>
            </form>
        </modal>
    </div>
</template>

<script>
import TreeTable from '@/components/TreeTable/TreeTable'
import Modal from '@/components/Modal'

export default {
    components: { TreeTable, Modal },
    name: 'detentions',
    data() {
        return {
            headers: [
                {
                    title: 'Id',
                    data: 'id'
                },
                {
                    title: this.$i18n.t('message.detenciones.nombre'),
                    data: 'description'
                },
                {
                    title: this.$i18n.t('message.detenciones.estado'),
                    data: 'state',
                    render: (row) => `<span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium leading-4 bg-${row.enable === 1 ? 'green' : 'red'}-100 text-${row.enable === 1 ? 'green' : 'red'}-800">
                            ${row.enable === 1 ? this.$i18n.t('message.detenciones.habilitado') : this.$i18n.t('message.detenciones.desabilitado')}
                        </span>`
                },
                {
                    title: this.$i18n.t('message.detenciones.opciones'),
                    actions: [
                        {
                            render: `<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                    </svg>`,
                            className: 'bg-blue-400',
                            action: (row) => this.obtainDetentionById(row)
                        },
                        {
                            render: `<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                    </svg>`,
                            className: 'bg-yellow-400',
                            action: (row) => this.createDetentionWithParent(row.id)
                        },
                        {
                            render: `<svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                    </svg>`,
                            className: 'bg-green-400',
                            action: (row) => this.changeState(row.id, row.enable)
                        }
                    ]
                }
            ],
            data: [],
            dataList: [],
            dataListFiltered: [],
            idDetention: false,
            openModalCreate: false,
            formData: {},
            isSupport: false
        };
    },
    async mounted(){
        await this.fetchPermissionsCurrentUser();
        await this.fetchCodStates();
        await this.fetchDataList();
    },
    methods: {
        async fetchPermissionsCurrentUser(){
            const { data } = await this.$http.get(`/users/permissions`);
            this.isSupport = data.support;
        },
        async fetchCodStates(){
            const { data } = await this.$http.get(`/cod_state?all=1`);
            this.data = data;
        },
        setInDataNested(data, codStateToAdd){
            let objFiltered = data.find(el => el.id === codStateToAdd.parent_id);
            if (!objFiltered || Object.keys(objFiltered).length === 0)
                data?.forEach(el => this.setInDataNested(el.children, codStateToAdd));
            else{
                this.$set(objFiltered, 'children', [...(objFiltered.children ?? []), codStateToAdd]);
            }
        },
        assignCodStateToData(codState, id){
            const codStateToAdd = {
                ...codState,
                id: id,
                enable: 1
            };

            if (codStateToAdd.parent_id){
                this.setInDataNested(this.data, codStateToAdd);
            }else
                this.data.push(codStateToAdd);
        },
        async createDetention(payload){
            const response = await this.$http.post(`/cod_state`, payload).catch(err => err);
            if (response.data?.result){
                this.assignCodStateToData(payload.cod_state, response.data.result);
                this.openModalCreate = false;
                this.fetchDataList();
            }else
                alert(response.response.data.message);
        },
        appendDetention(data, dataToMove){
            let objFiltered = data?.find(el => el.id === dataToMove.parent_id);
            if (!objFiltered || Object.keys(objFiltered).length === 0)
                data?.forEach(el => this.appendDetention(el.children, dataToMove));
            else
                this.$set(objFiltered, 'children', [...objFiltered.children, dataToMove]);
        },
        changeDetention(data, id, newData){
            let indexFiltered = data?.findIndex(el => el.id === id);
            if (indexFiltered < 0)
                data?.forEach(el => this.changeDetention(el.children, id, newData));
            else{
                if(data[indexFiltered].parent_id === newData.parent_id){
                    for(let key in newData)
                        this.$set(data[indexFiltered], key, newData[key]);
                }else{
                    for(let key in newData)
                        this.$set(data[indexFiltered], key, newData[key]);
                    const dataToMove = data.splice(indexFiltered, 1)[0];
                    if (dataToMove.parent_id === null)
                        this.data.push(dataToMove);
                    else
                        this.appendDetention(this.data, dataToMove);
                }
            }
        },
        async editDetention(id, payload){
            const response = await this.$http.put(`/cod_state/${id}?all=1`, payload).catch(err => err);
            if (response.data?.result){
                this.changeDetention(this.data, id, payload.cod_state);
                this.openModalCreate = false;
                this.fetchDataList();
            }else
                alert(response.response.data.message);
        },
        submitForm(){
            const payload = {
                cod_state: {
                    ...this.formData,
                    parent_id: this.formData.parent_id === '' ? null : this.formData.parent_id
                }
            };
            if (this.idDetention === false)
                this.createDetention(payload);
            else
                this.editDetention(this.idDetention, payload)
        },
        async fetchDataList(){
            const { data } = await this.$http.get(`/cod_state?all=1&list=1`);
            this.dataList = data;
        },
        showModal(data={}){
            this.idDetention = false;
            this.formData = {...data};
            this.openModalCreate = true;
        },
        async obtainDetentionById(item){
            const { data } = await this.$http.get(`/cod_state/${item.id}?all=1`);
            this.formData = data;
            this.idDetention = item.id;
            this.openModalCreate = true;
        },
        deleteDetentionOnList(data, id){
            let indexFiltered = data?.findIndex(el => el.id === id);
            if (indexFiltered >= 0)
                data.splice(indexFiltered, 1);
            else
                data?.forEach(el => this.deleteDetentionOnList(el.children, id));
        },
        async deleteDetention(id){
            if(window.confirm(this.$i18n.t('message.detenciones.confirmarborrar'))){
                const response = await this.$http.delete(`/cod_state/${id}?all=1`).catch(err => err);
                if (response.data?.result){
                    this.deleteDetentionOnList(this.data, id);
                    this.fetchDataList();
                }else
                    alert(response.response.data.message);
            }
        },
        createDetentionWithParent(parentId){
            this.showModal({parent_id: parentId});
        },
        changeStateDetention(data, id, enableUpdated){
            let objFiltered = data?.find(el => el.id === id);
            if (!objFiltered || Object.keys(objFiltered).length === 0)
                data?.forEach(el => this.changeStateDetention(el.children, id, enableUpdated));
            else
                this.$set(objFiltered, 'enable', enableUpdated);
        },
        async changeState(id, enable){
            if(window.confirm(this.$i18n.t(`message.detenciones.${enable === 1 ? 'confirmardesactivar' : 'confirmaractivar'}`))){
                const enableUpdated = enable === 1 ? 0 : 1;
                const payload = {
                    cod_state: {
                        enable: enableUpdated
                    }
                };
                const response = await this.$http.put(`/cod_state/${id}?all=1`, payload).catch(err => err);
                if (response.data?.result){
                    this.changeStateDetention(this.data, id, enableUpdated);
                }else
                    alert(response.response.data.message);
            }
        }
    },
    watch: {
        openModalCreate(open){
            if (open === true)
                this.dataListFiltered = this.dataList.filter(el => el.id !== this.idDetention);
        }
    }
};
</script>
